import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import LoadingSpinner from './LoadingSpinner';

const OnboardingGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { subscriptionStatus, hasCompanyDetails, loading } = useSubscription();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (subscriptionStatus === 'pending') {
    if (!hasCompanyDetails) {
      return <Navigate to="/onboarding/company-details" replace />;
    }
    return <Navigate to="/onboarding/subscription" replace />;
  }

  return <>{children}</>;
};

export default OnboardingGuard;
